import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getCanonical } from 'store/selectors/application';

// Prepends the Application's base URL to the given path
const withCanonical = (path) =>
	connect(createSelector(getCanonical(path), (canonical) => ({ canonical })));

export default withCanonical;
